module.exports = __webpack_public_path__ + "img/img7.47151440.jpg";